import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import ResolveLogo from 'assets/images/resolve-short.webp';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import DesktopAppContext from 'router/subrouters/DataRoom/providers/DesktopApp/DesktopApp.context';
import { DOWNLOAD_SOURCE } from 'models/MixpanelEvents';
import { SIZE } from 'models/Size';

import './ProtectedFilesBadge.styles.scss';

type ProtectedFilesBadgeProps = {
  className?: string;
};

const ProtectedFilesBadge: React.FC<ProtectedFilesBadgeProps> = (props) => {
  const { className } = props;

  const {
    dataRoom: { _id, name },
    isMaximumSecurity,
  } = useContext(DataRoomContext);
  const { downloadLink, trackDownload } = useContext(DesktopAppContext);

  const classes = classNames('protected-files-badge', className);

  const { t } = useTranslation();

  if (!downloadLink || !isMaximumSecurity) return null;

  return (
    <a
      className={classes}
      href={downloadLink}
      onClick={() => trackDownload(DOWNLOAD_SOURCE.DATA_ROOM_FOOTER, _id, name)}
    >
      <div>
        <ResolveImage src={ResolveLogo} loaderSize={SIZE.SMALL} />
      </div>

      <div>
        <p>{t('protectedFiledsRequireApp')}</p>
        <p>{t('clickToDownloadProtecetdApp')}</p>
      </div>
    </a>
  );
};

export default ProtectedFilesBadge;
